/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import type { JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      mesh438610892: Mesh
      mesh438610892_1: Mesh
      group1669640596: Mesh
    }
    materials: {
      mat12: MeshStandardMaterial
      mat21: MeshStandardMaterial
      mat8: MeshStandardMaterial
    }
  }

export function Popcorn(props: JSX.IntrinsicElements['group']) {
  const { nodes, materials } = useGLTF('/models/popcorn.glb') as GLTFResult
  return (
    <group {...props} dispose={null}>
      <group position-y={1.13}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.group1669640596.geometry}
          material={materials.mat8}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.mesh438610892.geometry}
          material={materials.mat12}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.mesh438610892_1.geometry}
          material={materials.mat21}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/models/popcorn.glb')
